import { MeterRegisterRateName } from "@/api/model/meterRegisterRateName"

const getRegisterRateIcon = (
  rateName?: MeterRegisterRateName,
): "Day" | "Night" => (rateName === MeterRegisterRateName.day ? "Day" : "Night")

export default getRegisterRateIcon
